import { FC } from 'react';
import { AgentScope } from '@/types/agents';

const LABELS: Record<AgentScope, string> = {
  PERSONAL: 'Pessoal',
  SECTOR: 'Setor',
  GLOBAL: 'Global',
};

const STYLES: Record<AgentScope, string> = {
  PERSONAL: 'bg-accent/15 text-accent',
  SECTOR: 'bg-blue-500/15 text-blue-300',
  GLOBAL: 'bg-emerald-500/15 text-emerald-300',
};

const ScopeBadge: FC<{ scope: AgentScope; className?: string }> = ({ scope, className = '' }) => (
  <span
    data-testid="scope-badge"
    className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full font-medium ${STYLES[scope]} ${className}`}
  >
    {LABELS[scope]}
  </span>
);

export default ScopeBadge;
